// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: f-0VpLbZdsD
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import SelectBizClass from "../../SelectBizClass"; // plasmic-import: vWhk9cqiwZ0/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingBusinessDetails.module.css"; // plasmic-import: f-0VpLbZdsD/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingBusinessDetails__VariantProps = new Array();

export const PlasmicOnboardingBusinessDetails__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingBusinessDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectIndustry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "suite.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__qwPyv)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__u88Cf
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__zHj7Q)}>
            <div className={classNames(projectcss.all, sty.freeBox__fzmy4)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__c6Hr6)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fj5Mf)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__qVsm)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__nwxLb)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hi2OX)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__jl8Ln)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ern3C)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__u64Zc)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__w0El9)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__j3Yu6)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mdmwT
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__g0Hue
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___3S7U
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__uoxde
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nBkYt
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__lm7Wy)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__n7N
                )}
              >
                {
                  "Astrius collects this information to meet the requirements of our regulators and financial partners."
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__rogQk)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___0M1R8)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xvGcr
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <div
                    data-plasmic-name={"firstNameError"}
                    data-plasmic-override={overrides.firstNameError}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.firstNameError
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small") ? (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Must complete all required fields"}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"First Name is required field"}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__cbGdr)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__tAggW
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"lastNameError"}
                data-plasmic-override={overrides.lastNameError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.lastNameError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Last Name is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___0LeKq)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__trx1N
                  )}
                >
                  {"Legal Business Name"}
                </div>
                <input
                  data-plasmic-name={"legalBusinessName"}
                  data-plasmic-override={overrides.legalBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.legalBusinessName
                  )}
                  placeholder={"Company"}
                  ref={ref => {
                    $refs["legalBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"legalNameError"}
                  data-plasmic-override={overrides.legalNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.legalNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Legal Business Name is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__qwcot)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__dvoQ7
                  )}
                >
                  {"Display Business Name"}
                </div>
                <input
                  data-plasmic-name={"displayBusinessName"}
                  data-plasmic-override={overrides.displayBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.displayBusinessName
                  )}
                  placeholder={""}
                  ref={ref => {
                    $refs["displayBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div
                data-plasmic-name={"displayNameError"}
                data-plasmic-override={overrides.displayNameError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.displayNameError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Display Business Name is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__v8Bk3)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__hyHay
                  )}
                >
                  {"Website"}
                </div>
                <input
                  data-plasmic-name={"website"}
                  data-plasmic-override={overrides.website}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.website
                  )}
                  placeholder={""}
                  ref={ref => {
                    $refs["website"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"linkError"}
                  data-plasmic-override={overrides.linkError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.linkError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Website Link is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__aawI3)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mdkz7
                  )}
                >
                  {"Employer Identification Number (EIN)"}
                </div>
                <input
                  data-plasmic-name={"ein"}
                  data-plasmic-override={overrides.ein}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ein
                  )}
                  placeholder={"12-3456789"}
                  ref={ref => {
                    $refs["ein"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"einError"}
                  data-plasmic-override={overrides.einError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.einError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"EIN is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__vuNpy)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lfBxo
                  )}
                >
                  {"Registered Business Address"}
                </div>
                <input
                  data-plasmic-name={"textInput"}
                  data-plasmic-override={
                    overrides.textInput ?? overrides.textbox
                  }
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textInput
                  )}
                  placeholder={"12-3456789"}
                  size={1}
                  type={"text"}
                  value={"United States"}
                />

                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  placeholder={"Address Line 1"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"addressError"}
                  data-plasmic-override={overrides.addressError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.addressError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Address is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"suite"}
                  data-plasmic-override={overrides.suite}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.suite
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["suite", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Suite Number"}
                  ref={ref => {
                    $refs["suite"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["suite", "value"]) ?? ""
                  }
                />

                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"cityError"}
                  data-plasmic-override={overrides.cityError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.cityError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"City is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <SelectState
                  data-plasmic-name={"selectState"}
                  data-plasmic-override={overrides.selectState}
                  className={classNames("__wab_instance", sty.selectState)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectState",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"State"}
                  value={p.generateStateValueProp($state, [
                    "selectState",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"stateError"}
                  data-plasmic-override={overrides.stateError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.stateError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"State is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"zipError"}
                  data-plasmic-override={overrides.zipError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.zipError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Zip Code is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__nes57)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mtTf4
                  )}
                >
                  {"Industry"}
                </div>
              </div>
              <SelectBizClass
                data-plasmic-name={"selectIndustry"}
                data-plasmic-override={overrides.selectIndustry}
                className={classNames("__wab_instance", sty.selectIndustry)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectIndustry",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectIndustry",
                  "value"
                ])}
              />

              <div
                data-plasmic-name={"industryError"}
                data-plasmic-override={overrides.industryError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.industryError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Industry is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__eiECe)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___2Alql
                  )}
                >
                  {"Monthly credit card processing volume"}
                </div>
                <div
                  data-plasmic-name={"monthlyVolume"}
                  data-plasmic-override={overrides.monthlyVolume}
                  className={classNames(projectcss.all, sty.monthlyVolume)}
                />
              </div>
              <div
                data-plasmic-name={"volumeError"}
                data-plasmic-override={overrides.volumeError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.volumeError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Processing Volume is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___9Kx3T)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__xnE
                  )}
                >
                  {"Average transaction size for credit card payments"}
                </div>
                <div
                  data-plasmic-name={"averageTicket"}
                  data-plasmic-override={overrides.averageTicket}
                  className={classNames(projectcss.all, sty.averageTicket)}
                />
              </div>
              <div
                data-plasmic-name={"averageTransactionError"}
                data-plasmic-override={overrides.averageTransactionError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.averageTransactionError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Average Transaction is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__p9Kgz)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zsDxn
                  )}
                >
                  {
                    "Highest estimated transaction size for credit card payments"
                  }
                </div>
                <div
                  data-plasmic-name={"highestTicket"}
                  data-plasmic-override={overrides.highestTicket}
                  className={classNames(projectcss.all, sty.highestTicket)}
                />
              </div>
              <div
                data-plasmic-name={"highestEstimationError"}
                data-plasmic-override={overrides.highestEstimationError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.highestEstimationError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Highest Estimation Transaction is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"einlengtherror"}
                data-plasmic-override={overrides.einlengtherror}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.einlengtherror
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"EIN can only contain 9 digits"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__sWhnM
                  )}
                >
                  {"Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "firstName",
    "firstNameError",
    "lastName",
    "lastNameError",
    "legalBusinessName",
    "legalNameError",
    "displayBusinessName",
    "displayNameError",
    "website",
    "linkError",
    "ein",
    "einError",
    "textInput",
    "textbox",
    "address1",
    "addressError",
    "suite",
    "city",
    "cityError",
    "selectState",
    "stateError",
    "zip",
    "zipError",
    "selectIndustry",
    "industryError",
    "monthlyVolume",
    "volumeError",
    "averageTicket",
    "averageTransactionError",
    "highestTicket",
    "highestEstimationError",
    "einlengtherror",
    "errorText",
    "continueButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  firstName: ["firstName"],
  firstNameError: ["firstNameError"],
  lastName: ["lastName"],
  lastNameError: ["lastNameError"],
  legalBusinessName: ["legalBusinessName"],
  legalNameError: ["legalNameError"],
  displayBusinessName: ["displayBusinessName"],
  displayNameError: ["displayNameError"],
  website: ["website"],
  linkError: ["linkError"],
  ein: ["ein"],
  einError: ["einError"],
  textInput: ["textInput", "textbox"],
  address1: ["address1"],
  addressError: ["addressError"],
  suite: ["suite"],
  city: ["city"],
  cityError: ["cityError"],
  selectState: ["selectState"],
  stateError: ["stateError"],
  zip: ["zip"],
  zipError: ["zipError"],
  selectIndustry: ["selectIndustry"],
  industryError: ["industryError"],
  monthlyVolume: ["monthlyVolume"],
  volumeError: ["volumeError"],
  averageTicket: ["averageTicket"],
  averageTransactionError: ["averageTransactionError"],
  highestTicket: ["highestTicket"],
  highestEstimationError: ["highestEstimationError"],
  einlengtherror: ["einlengtherror"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingBusinessDetails__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingBusinessDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBusinessDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBusinessDetails";
  } else {
    func.displayName = `PlasmicOnboardingBusinessDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBusinessDetails = Object.assign(
  // Top-level PlasmicOnboardingBusinessDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    firstName: makeNodeComponent("firstName"),
    firstNameError: makeNodeComponent("firstNameError"),
    lastName: makeNodeComponent("lastName"),
    lastNameError: makeNodeComponent("lastNameError"),
    legalBusinessName: makeNodeComponent("legalBusinessName"),
    legalNameError: makeNodeComponent("legalNameError"),
    displayBusinessName: makeNodeComponent("displayBusinessName"),
    displayNameError: makeNodeComponent("displayNameError"),
    website: makeNodeComponent("website"),
    linkError: makeNodeComponent("linkError"),
    ein: makeNodeComponent("ein"),
    einError: makeNodeComponent("einError"),
    textInput: makeNodeComponent("textInput"),
    address1: makeNodeComponent("address1"),
    addressError: makeNodeComponent("addressError"),
    suite: makeNodeComponent("suite"),
    city: makeNodeComponent("city"),
    cityError: makeNodeComponent("cityError"),
    selectState: makeNodeComponent("selectState"),
    stateError: makeNodeComponent("stateError"),
    zip: makeNodeComponent("zip"),
    zipError: makeNodeComponent("zipError"),
    selectIndustry: makeNodeComponent("selectIndustry"),
    industryError: makeNodeComponent("industryError"),
    monthlyVolume: makeNodeComponent("monthlyVolume"),
    volumeError: makeNodeComponent("volumeError"),
    averageTicket: makeNodeComponent("averageTicket"),
    averageTransactionError: makeNodeComponent("averageTransactionError"),
    highestTicket: makeNodeComponent("highestTicket"),
    highestEstimationError: makeNodeComponent("highestEstimationError"),
    einlengtherror: makeNodeComponent("einlengtherror"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingBusinessDetails
    internalVariantProps: PlasmicOnboardingBusinessDetails__VariantProps,
    internalArgProps: PlasmicOnboardingBusinessDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBusinessDetails;
/* prettier-ignore-end */
